export const validateTaxID = (taxId?: string): boolean => {
  if (!taxId) {
    return false
  }
  // 檢查統編長度是否為8碼
  if (taxId.length !== 8) {
    return false
  }
  // 檢查統編是否為數字
  if (!/^\d+$/.test(taxId)) {
    return false
  }

  let lastTwoDigitIsSeven = false
  if (taxId[6] === '7') {
    lastTwoDigitIsSeven = true
  }

  const sum: number[] = []
  const multipliers = [1, 2, 1, 2, 1, 2, 4, 1] // 邏輯乘數

  for (let i = 0; i < multipliers.length; i++) {
    const digit = parseInt(taxId.charAt(i))
    // @ts-expect-error - TODO: fix this
    sum.push(digit * multipliers[i])
  }

  const oneDigit = sum.filter(digit => digit < 10) // 存放個位數的array
  const twoDigit = sum
    .filter(digit => digit > 9) // 找出加總後是二位數的數字
    .map((item) => {
      const str = item.toString()
      // @ts-expect-error - TODO: fix this
      const result = parseInt(str[0]) + parseInt(str[1]) // EX: item = 36 -> result = 9 (3 + 6)
      if (result > 9) {
        // 若拆分加總後還是大於10就在執行一次拆分加總(只有統編倒數第二位為7時才會發生)
        return 1 // 必定會是1
      }
      else {
        return result
      }
    })

  const resultList = [...oneDigit, ...twoDigit] // 乘積之和

  // 計算乘積之和
  const resultSum = resultList.reduce((total, item) => total + item, 0)

  if (resultSum % 5 === 0) {
    return true
  }
  else if (lastTwoDigitIsSeven && (resultSum - 1) % 5 === 0) {
    // 倒數第二位為7時可以取0或1其中一個被5整除就可以
    // 因第一次帶的是1若不通過就在帶0
    return true
  }
  else {
    return false
  }
}
